import * as angular from "angular";

import hierarchyControllersModule from "../hierarchy-controllers/hierarchyControllers.module";
import hierarchyGridModule from "../hierarchy-grid/hierarchy.module";
import hierarchyModalModule from "../hierarchy-modal/hierarchyModal.module";
import hierarchySidenavModule from "../hierarchy-nav/hierarchySideNav.module";
import { configRoute } from "./capsule.router";
import { CAPSULE_SERVICE, CapsuleService } from "./capsule.service";
import capsuleManagerGuideModule from "../capsule-manager-guide/capsuleManagerGuide.module";

export default angular
    .module("board.web.admin.capsule", [
        hierarchyGridModule,
        hierarchySidenavModule,
        hierarchyControllersModule,
        hierarchyModalModule,
        capsuleManagerGuideModule
    ])
    .service(CAPSULE_SERVICE, CapsuleService)
    .config(configRoute)
    .name;


// WEBPACK FOOTER //
// ./app/capsule/capsule.module.ts